import { render, staticRenderFns } from "./ElementLabelComponent.vue?vue&type=template&id=0139186e&scoped=true&"
import script from "./ElementLabelComponent.vue?vue&type=script&lang=ts&"
export * from "./ElementLabelComponent.vue?vue&type=script&lang=ts&"
import style0 from "./ElementLabelComponent.less?vue&type=style&index=0&id=0139186e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0139186e",
  null
  
)

export default component.exports